import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {uploaderSelector} from "../../../selectors";
import Local from "./Local";
import ThirdPartySearch from "./ThirdPartySearch";

export class Uploader extends PureComponent {
  static propTypes = {
    source: PropTypes.string
  };
  static defaultProps = {
    source: `local`
  };
  getSourceContent() {
    switch (this.props.source) {
      case `local`:
        return <Local />;
      case `google-search`:
        return <ThirdPartySearch source="google-search" />;
      case `shutterstock`:
        return <ThirdPartySearch source="shutterstock" />;
    }
    return <Local />;
  }
  render() {
    return (
      <div className="uploader">
        <div className="uploader__content">{this.getSourceContent()}</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  source: uploaderSelector(state).source
});

export default connect(mapStateToProps)(Uploader);
